// extracted by mini-css-extract-plugin
export default {"label":"AchievementField_label__ZFll0"};